import Head from 'expo-router/head';

import { EmailConsentPage } from '@/components/consent/EmailConsentPage';

export default function EmailConsentRoute() {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>

      <EmailConsentPage />
    </>
  );
}
